import { Spacer } from "shared/layout";
import { MutedText } from "shared/styles";
import { breakpoint } from "shared/styles/constants";
import styled from "styled-components";

export const StyledTillEvent = styled(MutedText)`
  @media print {
    display: none;
  }
`;

export const StyledEventHeader = styled(Spacer)`
  max-width: 900px;
  margin: 0 12px;

  ${breakpoint("m", "up")} {
    margin: 0;
    margin-right: 24px;
  }
`;
